module.exports = "/assets/data/39e7251a06bab966b16716e945d6d8de-CH5.data.json";